<template>
  <div>
    <div class="row" v-if="filteredReadings.length == 0">
      <div class="col-12">
        <div class="h-100">
          <div class="d-flex h-100 justify-content-center align-items-center">
            <img
              src="@/assets/img/tick_selector.png"
              class="img-fluid d-inline-block"
              alt="No charges have been applied to this account"
            />
            <p v-if="readings.length == 0" class="d-inline-block my-auto pl-2">
              No readings have been added to date.
            </p>
            <p
              v-else-if="filteredReadings.length == 0"
              class="d-inline-block my-auto pl-2"
            >
              No readings for current meter.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="table-div">
      <b-table
        class="tbl-sml _elec-readings-tbl2"
        striped
        text-center
        :items="mappedReadings"
        :fields="summaryFields"
        :per-page="3"
        @row-clicked="toggleObject"
      >
        <template slot="ReadingDate" slot-scope="data">
          {{ data.item.ReadingDate | moment("DD.MM.YY") }}
        </template>
        <template slot="MeterSerial" slot-scope="data">
          {{ data.item.Serial }}
        </template>
        <template
          v-for="register of registers"
          :slot="`${register.RegisterId}:${register.BillingTypeId}:${register.Tpr}`"
          slot-scope="data"
        >
          <span :key="register.RegisterId">
            <span
              v-for="registerReading of data.item.RegisterReadings.filter(
                (reading) =>
                  reading.MeterRegisterId === register.RegisterId &&
                  reading.BillingTypeId === register.BillingTypeId &&
                  reading.Tpr === register.Tpr
              )"
              :key="registerReading.Id"
            >
              {{ registerReading.Reading }}
            </span>
          </span>
        </template>
        <template slot="ReadingType" slot-scope="data">
          <p
            v-if="
              data.item.ReadingType === 'Customer' ||
              data.item.ReadingType === 'ChangeOfTenancy'
            "
          >
            C
          </p>
          <p v-else-if="data.item.ReadingType.includes('Estimate')">E</p>
          <p v-else-if="data.item.ReadingType === 'Deemed'">D</p>
          <p v-else>A</p>
        </template>
        <template slot="HEAD_ReadingType">
          <th class="d-inline">Reading Type</th>
          <div class="d-inline">
            <span class="d-inline">
              <span
                v-b-popover.hover.right.html="
                  '<div><b>A</b> - Actual Reading</div><br><div><b>C</b> - Customer Reading</div><br><div><b>E</b> - Estimated Reading</div><br><div><b>D</b> - Deemed Reading</div>'
                "
                title="Reading Type"
                class="pointer"
              >
                <i class="fa fa-question-circle" aria-hidden="true"></i>
              </span>
            </span>
          </div>
        </template>
        <template slot="AssociatedInvoices" slot-scope="data">
          <div
            v-if="
              data.item.AssociatedInvoices &&
              data.item.AssociatedInvoices.length > 0
            "
            class="d-flex justify-content-center"
          >
            <div
              v-for="(invoice, index) in data.item.AssociatedInvoices"
              :key="index"
              class="badge-billing-info"
            >
              <div v-if="billingInfo(invoice).length !== 0">
                {{ billingInfo(invoice)[0].StatementNumber }}
              </div>
            </div>
          </div>
          <div v-else @click="isBillable($event, data.item)">
            <switches
              :value="!data.item.DoNotBill"
              type-bold="true"
              theme="bootstrap"
              color="success"
              text-enabled="Included"
              text-disabled="Excluded"
            ></switches>
          </div>
        </template>
        <template slot="ValidationStatus" slot-scope="data">
          {{ data.value | validationStatus }}
        </template>      
      </b-table>
    </div>
  </div>
</template>

<script>
import elecReadingsMixin from "@/mixins/meterInfo/readings/elecReadings.js";

export default {
  name: "electricity-readings-nhh",
  mixins: [elecReadingsMixin],

  computed: {
    currentMeter() {
      return this.meters.reduce((latestMeter, currentMeter) =>
        latestMeter.Installed > currentMeter.Installed
          ? latestMeter
          : currentMeter
      );
    },

    meterConfigs() {
      return this.currentMeter.MeterConfigs;
    },

    filteredReadings() {
      let readings = this.readings;

      // Always apply the excluded readings filter
      readings = this.filterByExcludedReadings(readings);

      readings = readings.filter(
        (reading) => reading.Serial === this.currentMeter.Serial
      );
      readings = this.showOnlyCustomer
        ? this.filterByCustomer(readings)
        : readings;

      return readings;
    }
  },
};
</script>
<style scoped>
.badge-billing-info {
  border: 1px solid #28a745;
  color: #28a745;
  margin: 0.5em;
  min-width: 2em;
  border-radius: 0.2em;
}
</style>